import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { motion } from "framer-motion";
import { api, apiErr } from "../lib/api";
import { BrandLogo } from "../components/BrandLogo";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";
import { Loader2, ArrowLeft } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const nav = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) { toast.error("La password deve avere almeno 6 caratteri"); return; }
    if (password !== confirm) { toast.error("Le password non coincidono"); return; }
    setBusy(true);
    try {
      const { data } = await api.post("/auth/reset-password", { token, password });
      toast.success("Password aggiornata, accedi con le nuove credenziali");
      nav(data.role === "customer" ? "/account/login" : "/esercenti/login");
    } catch (err) { toast.error(apiErr(err)); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-[#0B0B0D] text-white flex flex-col">
      <div className="max-w-6xl mx-auto w-full px-4 h-16 flex items-center">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-white/60 hover:text-white" data-testid="reset-back"><ArrowLeft size={16} /> Torna al portale</Link>
      </div>
      <div className="flex-1 flex items-center justify-center px-4 pb-16">
        <motion.div initial={{ opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }} className="w-full max-w-sm">
          <div className="mb-6"><BrandLogo name="Pickfood" size={30} /></div>
          <h1 className="font-head text-2xl font-bold">Nuova password</h1>
          {!token ? (
            <p className="text-white/60 text-sm mt-3" data-testid="reset-notoken">Link non valido. Richiedi un nuovo reset da <Link to="/recupera-password" className="text-[#FFC400] hover:underline">qui</Link>.</p>
          ) : (
            <form onSubmit={submit} className="space-y-4 mt-3">
              <p className="text-white/55 text-sm">Scegli una nuova password per il tuo account.</p>
              <div>
                <Label htmlFor="pw" className="text-white/80">Nuova password</Label>
                <Input id="pw" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="reset-password"
                  className="h-11 mt-1 bg-white/5 border-white/10 text-white placeholder:text-white/35" placeholder="••••••••" />
              </div>
              <div>
                <Label htmlFor="pw2" className="text-white/80">Conferma password</Label>
                <Input id="pw2" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required data-testid="reset-confirm"
                  className="h-11 mt-1 bg-white/5 border-white/10 text-white placeholder:text-white/35" placeholder="••••••••" />
              </div>
              <Button type="submit" disabled={busy} data-testid="reset-submit"
                className="w-full h-11 bg-[#FFC400] hover:bg-[#E6AC00] text-[#0B0B0D] rounded-full text-base font-semibold">
                {busy ? <Loader2 className="animate-spin" /> : "Aggiorna password"}
              </Button>
            </form>
          )}
        </motion.div>
      </div>
    </div>
  );
}
